<template>
  <nuttrema-layout-page-content>

    <nuttrema-jumbotron>
      <h1>{{ $t('label.register') }}</h1>
      <h4>{{ $t('label.in_three_simple_steps') }}</h4>
    </nuttrema-jumbotron>

    <div class="page-create-instance__steps" >
      <el-steps :space="300" :active="activeStep" :align-center="true" finish-status="success">
        <el-step
          :title="$t('label.create_your_instance')"
          :description="$t('label.create_your_instance_desc')">
        </el-step>

        <el-step
          :title="$t('label.select_subscription_package')"
          :description="$t('label.select_subscription_package_desc')">
        </el-step>

        <el-step
          :title="$t('label.checkout')"
          :description="$t('label.checkout_desc')">
        </el-step>
      </el-steps>
    </div>

    <router-view></router-view>

    <template slot="footer">
      <nuttrema-footer></nuttrema-footer>
    </template>

  </nuttrema-layout-page-content>
</template>

<script>
import { get } from 'lodash';

import NuttremaLayoutPageContent from 'components/ui/layout/nuttrema-layout-page-content';
import NuttremaJumbotron from 'components/ui/panels/nuttrema-jumbotron';

import NuttremaFooter from 'components/ui/panels/nuttrema-footer';

export default {
  name: 'page-create-instance',
  components: {
    NuttremaFooter,
    NuttremaJumbotron,
    NuttremaLayoutPageContent,
  },
  data() {
    return {
      theme: 'register',
    };
  },
  computed: {
    activeStep() {
      this.theme = 'register';
      const route = get(this.$route, 'name', null);
      switch (route) {
        case 'create-instance-professional-step-one':
          return 0;
        case 'create-instance-professional-step-two':
          return 1;
        case 'create-instance-professional-checkout':
          return 2;
        default:
          return 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";

  @mixin el-steps(
    $success-color: #ffc107,
    $success-text-color: #ffc107,
    $process-color: #fff,
    $process-text-color: #fff
  ) {
    .el-steps {
      justify-content: center;

      /deep/ .el-step {
        .el-step__icon {
          width: 48px;
          height: 48px;
          font-size: 1.5em;
          background: transparent;
        }

        .el-step__line {
          top: 22px;
          left: calc(50% + 22px);
          right: calc(-50% + 23px);
        }

        .el-step__head {
          &.is-success {
            color: $success-color;
            border-color: $success-color;
            .el-step__line {
              background-color: $success-color;
            }
          }

          &.is-process {
            color: $process-color;
            border-color: $process-color;
            .el-step__line {
              // background-color: $process-color;
            }
          }
        }

        .el-step__description {
          line-height: 1.25;
        }

        .el-step__title, .el-step__description {
          &.is-success {
            color: $success-text-color;
          }
          &.is-process {
            color: $process-text-color;
          }
        }
      }
    }
  }

  .page-create-instance__steps {
    display: flex;
    flex-shrink: 0;
    padding: 1.5em 1em;
    margin-bottom: 1.5em;
    border-radius: 0.75em;
    justify-content: center;
    background-color: rgba($primary-color-darker, 0.65);

    @include el-steps;

    &.theme-topography, .nuttrema-theme-professional-topography & {
      background-color: transparent;
      @include el-steps(#00C176, darken(#00C176, 5%), #465568, #465568);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/professional/public/create-instance/page-create-instance.vue